import { RawFilters } from '@b2b/common/components/advanced-filters';
import { Pagination, Timestamp } from '@b2b/types/core';
import * as z from 'zod';

export interface CustomersIndividualsListContext {
  searchMode: 'search' | 'advancedSearch';
  searchQuery: string;
  rawFilters: RawFilters;
}

export type FetchCustomersProps = Pagination & { search: string; startDate: Timestamp; endDate: Timestamp };

export const rawFiltersSchema = z.object({
  email: z.string().min(1),
  lastName: z.string().min(1),
});
